/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_SubtitleInputs */

const en_ui_volume_subtitle = /** @type {(inputs: Ui_Volume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added up over the range`)
};

const de_ui_volume_subtitle = /** @type {(inputs: Ui_Volume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsummiert über den Zeitraum`)
};

/**
* | output |
* | --- |
* | "Added up over the range" |
*
* @param {Ui_Volume_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_subtitle = /** @type {((inputs?: Ui_Volume_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_subtitle(inputs)
	return de_ui_volume_subtitle(inputs)
});